
import { mapGetters, mapActions } from "vuex"
import layoutMixin from "@/mixins/layout"
import { UserNavLink, isPathBelongsToLink } from "@/utils/user-nav"
import { DeletionRequestVars } from "@/types/api/user"

export default layoutMixin.extend({
  middleware: [
    "auth",

    async ({ route, store }) => {
      if (route.params.eventAlias)
        await store.dispatch("program/fetchHasSessions", route.params.eventAlias)
    },

    ({ route, store, error }) => {
      const nav = store.getters["user/nav"]

      const currLink = nav.find(
        (link: UserNavLink) => isPathBelongsToLink(link, route.path),
      )

      if (!currLink)
        error({ statusCode: 404 })
    },
  ],

  data: () => ({
    variables: {} as DeletionRequestVars,
    removeDialogOpened: false,
    idDialogOpened: false,
    feedbackDialogOpened: false,
    accDeletion: false,
  }),

  computed: {
    ...mapGetters("user", ["user", "nav", "accountDeletion"]),

    accountMerging (): boolean {
      return this.accountDeletion?.deleteReason === "OTHER_ACCOUNT"
    },

    currLink (): UserNavLink | null {
      const currLink = this.nav.find(
        (link: UserNavLink) => isPathBelongsToLink(link, this.$route.path),
      )

      return currLink || null
    },
  },

  async beforeMount () {
    const [res, err] = await this.$api.user.findUserDeleteRequest({
      params: {
        event: this.$config.event,
      },
    })

    if (err)
      console.error(err || this.$t("unknownError"))
    else if (res?.id)
      this.setAccDeletion(res)
  },

  mounted () {
    const data = this.accountDeletion
    if (
      localStorage.getItem("removal_modal_closed") &&
      data?.deleteReason === "OTHER_ACCOUNT" &&
      data?.secondUser
    ) return
    this.accDeletion = Boolean(data)
  },

  watch: {
    accountDeletion (val) {
      if (
        localStorage.getItem("removal_modal_closed") &&
        val?.deleteReason === "OTHER_ACCOUNT" &&
        val?.secondUser
      ) return
      this.accDeletion = Boolean(val)
    },
  },

  methods: {
    ...mapActions("user", { setAccDeletion: "SET_ACCOUNT_DELETION" }),

    updateLS () {
      localStorage.setItem("removal_modal_closed", "true")
    },
  },
})
